import * as hj from 'react-hotjar';
class HotjarTracker {
    constructor(config) {
        this.name = 'hotjar';
        this.trackActivity = (params) => {
            const { user = { id: null }, ...properties } = params;
            hj.hotjar.identify(user.id, { ...properties });
        };
        const { hjid, hjsv } = config;
        this.name = 'hotjar';
        hj.hotjar.initialize(hjid, hjsv);
    }
}
export default HotjarTracker;
//# sourceMappingURL=hotjar.js.map